var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.15541 18.8333C6.82899 18.8348 6.51503 18.6815 6.28067 18.4061L0.37744 11.4624C0.259778 11.3232 0.165894 11.1572 0.101148 10.974C0.0364024 10.7907 0.00206288 10.5938 9.0224e-05 10.3945C-0.00389373 9.99199 0.124201 9.60403 0.356196 9.31598C0.588191 9.02793 0.905082 8.86339 1.23716 8.85856C1.56923 8.85373 1.88929 9.00901 2.12691 9.29023L7.1604 15.2084L17.8722 2.59797C18.1102 2.31675 18.4305 2.16164 18.7628 2.16675C19.0951 2.17186 19.4122 2.33678 19.6442 2.62524C19.8762 2.91369 20.0041 3.30204 19.9999 3.70485C19.9957 4.10767 19.8596 4.49196 19.6217 4.77318L8.03014 18.4061C7.79578 18.6815 7.48182 18.8348 7.15541 18.8333Z",
    fill: "#046C4E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckmark);
export default __webpack_public_path__ + "static/media/green-checkmark.79b4832573110e86d1dad09d4c1ffc35.svg";
export { ForwardRef as ReactComponent };